import {API_BASE} from '../apiConfig';
import {getLobbyNetworkIdentity} from './guestViewer';

/**
 * Создать обычное лобби от имени игрока.
 *
 * Тот же запрос, что и у кнопки «+ Создать обычное лобби» в списке лобби
 * (LobbyListPage): сервер заводит лобби в сборе, а дальше сам подсаживает
 * туда соперников — скрытых ботов под видом присоединившихся игроков (см.
 * scheduleLobbyBotChurn). Поэтому приглашению новичка («Найти соперников» в
 * OnlineMatchPromoModal) искать лобби в списке не нужно: достаточно собрать
 * свое.
 *
 * @param {Object} auth - профиль игрока (из него берутся имя и сетевой id)
 * @returns {Promise<string|null>} id созданного лобби; null — не получилось
 */
export const createOwnLobby = async (auth) => {
  const {id: playerId, name: playerName} = getLobbyNetworkIdentity(auth);
  try {
    const response = await fetch(`${API_BASE}/lobbies`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({playerName, playerId}),
    });
    if (!response.ok) {
      console.error('[CreateOwnLobby] failed', response.status);
      return null;
    }
    const data = await response.json();
    return data?.lobbyId || null;
  } catch (error) {
    console.error('[CreateOwnLobby] failed', error);
    return null;
  }
};
